export const fetchYear = (year, calendar) =>
  fetch(
    `https://api.mlab.com/api/1/databases/kalendae/collections/${calendar}?q={Year:${year}}&apiKey=${
      process.env.REACT_APP_MLAB_KEY
    }`
  ).then(res => res.json())
